import { z } from "zod";

import { TRawBaseInfoField } from "../../infoField";

export type IIncomeDataRent = z.infer<typeof TIncomeDataRent>;
export const TIncomeDataRent = z.object({
  description: z.string().nullish(),
  periodType: z.number().nullish(),
  quantity: z.number().nullish(),
  // TODO - Later change to just string or number
  sum: z.union([z.string(), z.number(), z.null(), z.undefined()]).transform((v) => (typeof v === "string" ? parseFloat(v) : typeof v === "number" ? v : 0)),
});

export type IRawIncomeDataInfoFieldValue = z.infer<typeof TRawIncomeDataInfoFieldValue>;
export const TRawIncomeDataInfoFieldValue = z
  .object({
    value: z
      .object({
        areaRent: z.array(TIncomeDataRent).optional(),
        commonRent: z.array(TIncomeDataRent).optional(),
        otherRent: z.array(TIncomeDataRent).optional(),
        parkingRent: z.array(TIncomeDataRent).optional(),
        totalPeriod: z.number(),
      })
      .nullish(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();

export type IRawIndexRegulationInfoFieldValue = z.infer<typeof TRawIndexRegulationInfoFieldValue>;
export const TRawIndexRegulationInfoFieldValue = z
  .object({
    value: z
      .object({
        active: z.boolean(),
        percentage: z.number().nullish(),
      })
      .nullish(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();

export type IJointAreaType = z.infer<typeof TJointAreaType>;
export const TJointAreaType = z.enum(["area", "percentage"]);

export type IRawJointAreaInfoFieldValue = z.infer<typeof TRawJointAreaInfoFieldValue>;
export const TRawJointAreaInfoFieldValue = z
  .object({
    value: z
      .object({
        type: TJointAreaType,
        value: z.number(),
      })
      .nullish(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();
